<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>Burndown Chart</v-toolbar-title>
    </v-toolbar>
    <GChart
      id="burndown"
      type="LineChart"
      :data="chartData"
      :options="chartOptions"
    />
  </v-card>
</template>

<script>
import { GChart } from 'vue-google-charts';
import moment from 'moment';

export default {
  name: 'BurndownChart',
  components: {
    GChart,
  },
  data() {
    return {
      // Array will be automatically processed with visualization.arrayToDataTable function
      chartOptions: {
        height: 400,
        chart: {
          title: 'Burndown Chart',
          subtitle: 'Sprint progress',
        },
        backgroundColor: '#424242',
      },
      idealLine: 0,
    };
  },
  methods: {
    getDates(startDate, endDate) {
      // Returns an array of dates between the two dates
      const dates = [];
      let currentDate = startDate;

      function addDays(days) {
        const date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      }

      while (currentDate <= endDate) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
      }
      return dates;
    },
  },
  computed: {
    sprint() {
      return this.$store.getters.getActiveSprint;
    },
    chartData() {
      const data = [];
      data.push(['Date', 'Ideal', 'Realised']);

      if (this.sprint) {
        const datesInSprint = this.getDates(new Date(this.sprint.start), new Date(this.sprint.end));

        const stories = this.$store.getters.getStoriesBySprint(this.sprint.id);
        const storyCount = stories.length;
        let storiesLeft = storyCount;

        let idealLine = storyCount;
        datesInSprint.forEach((date) => {
          stories.forEach((story) => {
            if (story.done_at && moment(story.done_at).format('YYYY-MM-DD') <= moment(date).format('YYYY-MM-DD')) {
              storiesLeft -= 1;
            }
          });
          data.push([moment(date).format('D-M'), idealLine, storiesLeft]);
          idealLine -= (storyCount / (datesInSprint.length - 1));
        });
      }

      return data;
    },
  },
};
</script>
